module.exports = __webpack_public_path__ + "img/anhui.de35969a.png";